var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import CloseIcon from "@material-ui/icons/Close";
import Chip from "@material-ui/core/Chip";
import { affinityColors as colors } from "../themes/affinityTheme/styleData";
export function ErrorChip(_a) {
    var label = _a.label, other = __rest(_a, ["label"]);
    return (React.createElement(Chip, __assign({ avatar: React.createElement(Avatar, { style: {
                backgroundColor: colors.affinityRedDarker.value,
                color: "white"
            } },
            React.createElement(CloseIcon, null)), label: label, style: {
            color: "white",
            backgroundColor: colors.affinityRedDark.value,
            margin: "0 15px"
        } }, other)));
}
ErrorChip.propTypes = {
    label: PropTypes.string
};
//# sourceMappingURL=ErrorChip.js.map